/** Notify native password managers only after confirmed authentication success.
 * Browsers and older iOS wrappers simply keep their normal AutoFill behavior.
 */
export function requestIOSPasswordSave(username: string, password: string): void {
  if (typeof window === 'undefined' || !username || !password) return;
  const host = window.location.hostname;
  if (window.location.protocol !== 'https:' ||
      !['main.church-services.org', 'main.church-services-staging.org'].includes(host)) return;
  const nativeWindow = window as Window & {
    AndroidBridge?: { commitAutofill?: () => void };
    webkit?: { messageHandlers?: { saveCredential?: {
      postMessage: (credential: { username: string; password: string }) => void;
    } } };
  };
  try {
    // Android reads the existing form through the OS AutoFill session; no password bridge.
    nativeWindow.AndroidBridge?.commitAutofill?.();
  } catch {
    // An unavailable Android provider must not affect authentication.
  }
  try {
    nativeWindow.webkit?.messageHandlers?.saveCredential?.postMessage({ username, password });
  } catch {
    // Saving is optional and must never turn a successful sign-in into an error.
  }
}
